import { useState, useEffect } from 'react';
import { generateOption1HTML } from './layouts/layoutOption1';
import { generateOption2HTML } from './layouts/layoutOption2';
import { generateOption3HTML } from './layouts/layoutOption3';
import { usePermissionGuard } from '../../adminPanelTools';
import styles from './previewPage.module.css';
function PreviewPage() {
    const checking = usePermissionGuard('handle_news');

    const draftToHtmlConfig = {
        entityToHTML: (entity, originalText) => {
            if (entity.type === 'LINK') {
                return `<a href="${entity.data.url}" target="_blank" rel="noopener noreferrer">${originalText}</a>`;
            }
            return originalText;
        },
    };

    const [content, setContent] = useState('');
    useEffect(() => {
        const data = JSON.parse(localStorage.getItem('previewContent'));
        if (!data) {
            setContent('<p>Keine Daten gefunden</p>');
            return;
        }

        let generatedHtml = '';

        switch (data.selectedLayout) {
            case 'option1':
                generatedHtml = generateOption1HTML(data);
                break;
            case 'option2':
                generatedHtml = generateOption2HTML(data);
                break;
            case 'option3':
                generatedHtml = generateOption3HTML(data);
                break;
            // default:
            //     generatedHtml = generateDefaultHTML(data);
        }

        setContent(generatedHtml);
    }, []);

    if (checking) {
        return <div className={styles.container}><p>Lade...</p></div>; // or return null if you want no UI at all
    }
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
}

export default PreviewPage;